import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { DatePicker, Space, Spin } from "antd";
import TextInput from "components/TextInput";
import { useTranslation } from "react-i18next";
import useAllStores from "hooks/useCurrentUserStores";
import useAllItems from "hooks/useCurrentUserItems";
import moment from "moment";
import "moment-timezone";
import { CONSTANTS as C } from "config";
import { UTILS } from "utils";
import AppSteps from "components/ui/AppSteps"
import AppInput from "components/ui/AppInput.jsx";
import AppRadioButton from "components/ui/AppRadioButton";
import AppDatePicker from "components/ui/AppDatePicker";
import AppButton from "components/ui/AppButton.jsx";
import AppCheckbox from "components/ui/AppCheckbox.jsx";

const DiscountForm = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { stores, loading } = useAllStores();
  const [searchTerm, setSearch] = useState("");
  const[currentStep,setCurrentStep]=useState(0);
  const zone = moment.tz.guess();
  moment.tz.setDefault(zone);
  const { items, Itemloader } = useAllItems();
  const { RangePicker } = DatePicker;

  const addStore = (store) => {
    console.log("store:", store);
    if (props?.state?.values?.selectedOutlets?.includes(store)) {
      const newSelectedOutlets = props?.state?.values?.selectedOutlets?.filter(
        (item) => item !== store
      );
      props?.setState({
        ...props.state,
        values: {
          ...props.state.values,
          selectedOutlets: newSelectedOutlets,
        },
      });
    } else {
      props.setState({
        ...props.state,
        values: {
          ...props.state.values,
          selectedOutlets: [...props.state.values.selectedOutlets, store],
        },
      });
    }
  };
  const addItem = (sitem) => {
    console.log("sitem:", sitem);
    if (props.state.values.selectedItems.includes(sitem)) {
      const newSelectedItems = props.state?.values?.selectedItems?.filter(
        (item) => item !== sitem
      );
      props.setState({
        ...props.state,
        values: {
          ...props.state.values,
          selectedItems: newSelectedItems,
        },
      });
    } else {
      props.setState({
        ...props.state,
        values: {
          ...props.state.values,
          selectedItems: [...props.state.values.selectedItems, sitem],
        },
      });
    }
  };
  const handleSetDate = (date, dateString) => {
    const momentTimezone = moment.tz.guess();
    const date1 = moment(date[0]).locale("en").tz(momentTimezone).format();
    const date2 = moment(date[1]).locale("en").tz(momentTimezone).format();

    props.setState({
      ...props.state,
      values: {
        ...props.state.values,
        startDate: dateString[0],
        endDate: dateString[1],
        isoDate: date1,
        isoEndDate: date2,
      },
    });
  };

  const handleChange = (key, val) => {
    props.setState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };
 
  const handleDiscountCode = (key, val) => {
    if (val.match(/[a-z]/i)) {
      val = val.toLowerCase();
    }
    props.setState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };

  const getValue = (key) => {
    if (props?.state && UTILS.ifNotNullAndUndfine(props.state.values[key])) {
      return props.state.values[key];
    }
    if (key === "startDate") {
      return moment().format("YYYY-MM-DD, HH:mm");
    }
    if (key === "endDate") {
      return moment().add(1, "year").format("YYYY-MM-DD, HH:mm");
    }

    return "";
  };
  const Items = React.useMemo(() => {
    if (searchTerm === "" || searchTerm === null) {
      return items;
    }
    let searchTermLower = searchTerm.toLowerCase().trim();

    return items.filter((item) =>
      item?.baseLanguage?.title?.toLowerCase()?.includes(searchTermLower)
    );
  }, [items, searchTerm]);

  const handSearch = (e) => {
    setSearch(e.target.value);
  };
  const updatePrice = (key, val) => {
    const value = UTILS.NumberConversion(val);
    handleChange(key, value);
  };

  const handleServiceTypes = (key, val) => {
    const isAdded = props?.state?.values?.serviceType?.some(
      (value) => value?.serviceName === val?.serviceName
    );
    const newSelectedItems = isAdded
      ? props?.state?.values?.serviceType?.filter(
          (item) => item?.serviceName !== val.serviceName
        )
      : [...props?.state?.values?.serviceType, val];

    props.setState({
      ...props.state,
      values: {
        ...props?.state?.values,
        serviceType: newSelectedItems,
      },
      errors: {
        ...props?.state.errors,
        [key]: "",
      },
    });
  };

  const getBuisnessType = () => {
    const userDetail = UTILS.getCurrentUser();
    return userDetail?.catalogueType;
  };

  const steps = [
    { title: "Discount Details" },
    { title: "Eligibility" },
    { title: "Usage Limit" },
    { title: "Scheduling" },
  ];

  const isSelectedOutlet = props?.state?.values?.outletSelectionType === C.SELECTED;
  const isSelectedItems = props?.state?.values?.itemSelectionType === C.SELECTED;
  const isPercentageDiscount = props?.state?.values?.discountType === C.PERCENTAGE;

  const lastStepIndex = steps.length - 1;

  const patchErrors = (partial) => {
    props.setState((prev) => ({
      ...prev,
      errors: { ...prev.errors, ...partial },
    }));
  };

  const validateStep0 = () => {
    const v = props.state.values;
    if (!String(v.discountName ?? "").trim()) {
      UTILS.errorNotification(t("Discount name is required"));
      patchErrors({ discountName: t("Discount name is required") });
      return false;
    }
    if (!String(v.discountCode ?? "").trim()) {
      UTILS.errorNotification(t("Coupon code is required"));
      patchErrors({ discountCode: t("Coupon code is required"), couponCode: t("Coupon code is required") });
      return false;
    }
    if (String(v.discountCode).match(/[^a-zA-Z0-9]/g)) {
      UTILS.errorNotification(
        t("Coupon code should not contain any special characters or spaces")
      );
      patchErrors({
        discountCode: t("Coupon code should not contain any special characters or spaces"),
        couponCode: t("Coupon code should not contain any special characters or spaces"),
      });
      return false;
    }
    if (v.discountAmount === "" || v.discountAmount == null || Number(v.discountAmount) <= 0) {
      UTILS.errorNotification(t("Discount amount must be greater than 0"));
      patchErrors({ discountAmount: t("Discount amount must be greater than 0") });
      return false;
    }
    if (
      v.discountType === C.PERCENTAGE &&
      Number(v.discountAmount) > 100
    ) {
      UTILS.errorNotification(
        t("Coupons with percentage types should not have an amount field greater than 100")
      );
      patchErrors({ discountAmount: t("Coupons with percentage types should not have an amount field greater than 100") });
      return false;
    }
    if (v.minOrderValue === "" || v.minOrderValue == null || Number.isNaN(Number(v.minOrderValue))) {
      UTILS.errorNotification(t("Minimum order value can't be empty"));
      patchErrors({ minOrderValue: t("Minimum order value can't be empty") });
      return false;
    }
    if (
      v.discountType === C.PERCENTAGE &&
      (v.maximumDiscountValue === "" ||
        v.maximumDiscountValue == null ||
        Number.isNaN(Number(v.maximumDiscountValue)) ||
        Number(v.maximumDiscountValue) <= 0)
    ) {
      UTILS.errorNotification(t("Maximum discount must be greater than zero"));
      patchErrors({ maximumDiscountValue: t("Maximum discount must be greater than zero") });
      return false;
    }
    patchErrors({
      discountName: "",
      discountCode: "",
      couponCode: "",
      discountAmount: "",
      minOrderValue: "",
      maximumDiscountValue: "",
    });
    return true;
  };

  const validateStep1 = () => {
    const v = props.state.values;
    if (!v.serviceType?.length) {
      UTILS.errorNotification(t("An order type selection is required"));
      return false;
    }
    if (v.outletSelectionType === C.SELECTED && (!v.selectedOutlets?.length)) {
      UTILS.errorNotification(t("Please select at least one store"));
      patchErrors({ storeSelection: t("Please select at least one store") });
      return false;
    }
    if (v.itemSelectionType === C.SELECTED && (!v.selectedItems?.length)) {
      UTILS.errorNotification(t("Please choose at least one item"));
      patchErrors({ itemSelection: t("Please choose at least one item") });
      return false;
    }
    if (
      v.perCustomerUse === "" ||
      v.perCustomerUse == null ||
      Number.isNaN(Number(v.perCustomerUse)) ||
      Number(v.perCustomerUse) <= 0
    ) {
      UTILS.errorNotification(t("Per customer use must be greater than zero"));
      patchErrors({ perCustomerUse: t("Per customer use must be greater than zero") });
      return false;
    }
    patchErrors({ storeSelection: "", itemSelection: "", perCustomerUse: "" });
    return true;
  };

  const validateStep2 = () => {
    const v = props.state.values;
    if (v.maxUsage === "" || v.maxUsage == null || Number.isNaN(Number(v.maxUsage)) || Number(v.maxUsage) <= 0) {
      UTILS.errorNotification(t("Total number of uses must be greater than zero"));
      patchErrors({ maxUsage: t("Total number of uses must be greater than zero") });
      return false;
    }
    patchErrors({ maxUsage: "" });
    return true;
  };

  const handleStepIndicatorChange = (index) => {
    if (index <= currentStep) setCurrentStep(index);
  };

  const handleCancelOrBack = () => {
    if (currentStep === 0) {
      history.push("/app/dashboard/discount");
    } else {
      setCurrentStep((s) => Math.max(0, s - 1));
    }
  };

  const handleNext = () => {
    if (currentStep === 0 && !validateStep0()) return;
    if (currentStep === 1 && !validateStep1()) return;
    if (currentStep === 2 && !validateStep2()) return;
    setCurrentStep((s) => Math.min(lastStepIndex, s + 1));
  };

  const handleSubmitDiscount = () => {
    props?.addDiscount?.();
  };

  const renderSelectionList = (data, selectedValues, onToggle, labelKey) => (
    <div className="mt-3 max-h-64 overflow-y-auto rounded-xl border border-gray-200 p-3">
      {data?.map((item, index) => {
        const value = item?.value || item?._id;
        const label = item?.label || item?.baseLanguage?.title || item?.[labelKey];
        const isChecked = selectedValues?.includes(value);
        const checkboxId = `discount-selection-${String(value ?? index)}`;

        return (
          <button
                key={`${value}-${index}`}
                type="button"
                className="flex w-full items-center justify-between rounded-md px-3 py-2 text-left hover:bg-gray-50"
                onClick={() => onToggle(value)}
              >
                <div>
                  <div className="text-sm font-medium text-gray-800">{label}</div>
                </div>
                <span
                  className={`block h-5 w-5 rounded border ${
                    isChecked ? "bg-blue-500 border-blue-500" : "bg-white border-gray-300"
                  }`}
                />
              </button>
          // <AppCheckbox
          //   key={`${value}-${index}`}
          //   id={checkboxId}
          //   className="w-full flex-row-reverse justify-between py-2"
          //   label={label}
          //   checked={isChecked}
          //   onChange={(e) => {
          //     e?.stopPropagation?.();
          //     onToggle(value);
          //   }}
          // />
        );
      })}
    </div>
  );

  return (
    <div className="discount-form flex min-h-0 w-full flex-1 flex-col">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden overscroll-y-contain">
      <div className="flex justify-center">
        <div className="my-3 w-full md:w-4/6">
          <AppSteps
            currentStep={currentStep}
            steps={steps}
            onChange={handleStepIndicatorChange}
          />
        </div>
      </div>
      {
        currentStep==0 &&
          <div className="my-3">
            <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
              <AppInput
                label={t("Discount name")}
                placeholder={t("E.g. Taco Tuesday!")}
                value={getValue("discountName")}
                error={props?.state?.errors?.discountName}
                mandatory={true}
                onChange={(e) => handleChange("discountName", e.target.value)}
              />
              <AppInput
                label={t("Discount code") +" " +t("Only small letters & numeric values are allowed")}
                placeholder={t("E.g. happy100")}
                value={getValue("discountCode")}
                error={props?.state?.errors?.couponCode || props?.state?.errors?.discountCode}
                mandatory={true}
                disabled={props?.text !== "Add"}
                onChange={(e) => handleDiscountCode("discountCode", e.target.value)}
              />
            </div>
            <div className="my-3">
              <label className="block text-sm font-semibold text-gray-900 mb-2">{t("Application")}</label>
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <AppRadioButton
                  name="applicationType"
                  value={C.COUPUN_APPLICATION_TYPE.MANUAL}
                  checked={props?.state?.values?.applicationType === C.COUPUN_APPLICATION_TYPE.MANUAL}
                  onChange={(value) => handleChange("applicationType", value)}
                  title={t("Manual")}
                  description={t("Will be displayed on the store front, and customers will have to select it if they wish to use it")}
                />
                <AppRadioButton
                  name="applicationType"
                  value={C.COUPUN_APPLICATION_TYPE.HIDDEN}
                  checked={props?.state?.values?.applicationType === C.COUPUN_APPLICATION_TYPE.HIDDEN}
                  onChange={(value) => handleChange("applicationType", value)}
                  title={t("Hidden Code")}
                  description={t("Won’t be displayed on the store front, and customers will type the code at the checkout")}
                />
              </div>
            </div>
            <div className="my-3">
              <label className="block text-sm font-semibold text-gray-900 mb-2">{t("Discount type")}</label>
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <AppRadioButton
                  name="discountType"
                  value={C.PERCENTAGE}
                  checked={isPercentageDiscount}
                  disabled={props?.text !== "Add"}
                  onChange={(value) => handleChange("discountType", value)}
                  title={t("Percentage") + " (%)"}
                />
                <AppRadioButton
                  name="discountType"
                  value="fixed"
                  checked={props?.state?.values?.discountType === "fixed"}
                  disabled={props?.text !== "Add"}
                  onChange={(value) => handleChange("discountType", value)}
                  title={t("Fixed value") + " ($)"}
                />
              </div>
            </div>
            <div className="my-3 grid grid-cols-1 gap-3 md:grid-cols-2">
              <AppInput
                label={t("Amount")}
                placeholder={t("E.g. 20")}
                value={getValue("discountAmount")}
                error={props?.state?.errors?.discountAmount}
                mandatory={true}
                onChange={(e) => updatePrice("discountAmount", e.target.value)}
              />
            </div>
            <div className="my-3 grid grid-cols-1 gap-3 md:grid-cols-2">
              <AppInput
                label={t("Minimum order value")}
                value={getValue("minOrderValue")}
                error={props?.state?.errors?.minOrderValue}
                mandatory={true}
                onChange={(e) => updatePrice("minOrderValue", e.target.value)}
              />
              <AppInput
                label={t("Maximum discount")}
                value={getValue("maximumDiscountValue")}
                error={props?.state?.errors?.maximumDiscountValue}
                disabled={!isPercentageDiscount}
                mandatory={isPercentageDiscount}
                onChange={(e) => updatePrice("maximumDiscountValue", e.target.value)}
              />
            </div>

          </div>
      }
      {
        currentStep==1 &&
          <div>
            <div className="my-3">
              <label className="block text-sm font-semibold text-gray-900 mb-2">{t("Order type")}</label>
              {
                <div className="flex flex-wrap gap-3">
                  {[
                    {
                      label: t("DELIVERY"),
                      serviceName: "DELIVERY",
                    },
                    {
                      label: t("PICKUP"),
                      serviceName: "PICKUP",
                    },
                    ...(getBuisnessType() !== C.BRAND_BASED
                      ? [
                          {
                            label: t("DINEIN"),
                            serviceName: "DINE IN",
                          },
                        ]
                      : []),
                  ].map((item, index) => (
                    <AppCheckbox
                      key={`${item?.serviceName}-${index}`}
                      label={item?.label}
                      checked={props?.state?.values.serviceType.some(
                        (service) => service.serviceName === item?.serviceName
                      )}
                      onChange={() =>
                        handleServiceTypes("orderType", {
                          serviceName: item?.serviceName,
                        })
                      }
                    />
                  ))}
                </div>
              }
            </div>
            <div className="my-3">
              <label className="block text-sm font-semibold text-gray-900 mb-2">{t("Applicable outlets")}</label>
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <AppRadioButton
                  name="outletSelectionType"
                  value={C.ALL}
                  checked={props?.state?.values?.outletSelectionType === C.ALL}
                  onChange={(value) => handleChange("outletSelectionType", value)}
                  title={t("All Outlets")}
                />
                <AppRadioButton
                  name="outletSelectionType"
                  value={C.SELECTED}
                  checked={isSelectedOutlet}
                  onChange={(value) => handleChange("outletSelectionType", value)}
                  title={t("Selected Outlets")}
                />
              </div>
              {isSelectedOutlet &&
                renderSelectionList(
                  stores,
                  props?.state?.values?.selectedOutlets,
                  addStore,
                  "label"
                )}

            </div>
            
            <div className="my-3">
              <label className="block text-sm font-semibold text-gray-900 mb-2">{t("Customer segmentation")}</label>
              <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <AppRadioButton
                  name="customerSegmentationType"
                  value="all"
                  checked={props?.state?.values?.customerSegmentationType === "all"}
                  onChange={(value) => handleChange("customerSegmentationType", value)}
                  title={t("All customers")}
                />
                <AppRadioButton
                  name="customerSegmentationType"
                  value="new"
                  checked={props?.state?.values?.customerSegmentationType === "new"}
                  onChange={(value) => handleChange("customerSegmentationType", value)}
                  title={t("New customers")}
                />
              </div>
            </div>
            <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
              <AppInput
                label={t("Number of uses per customer")}
                value={getValue("perCustomerUse")}
                error={props?.state?.errors?.perCustomerUse}
                mandatory={true}
                onChange={(e) => updatePrice("perCustomerUse", e.target.value)}
              />
            </div>
            <div className="my-3">
              <label className="block text-sm font-semibold text-gray-900 mb-2">{t("Discount items")}</label>
              <div className="grid grid-cols-2 gap-3">
                <AppRadioButton
                  name="itemSelectionType"
                  value={C.ALL}
                  checked={props?.state?.values?.itemSelectionType === C.ALL}
                  onChange={(value) => handleChange("itemSelectionType", value)}
                  title={t("All items")}
                />
                <AppRadioButton
                  name="itemSelectionType"
                  value={C.SELECTED}
                  checked={isSelectedItems}
                  onChange={(value) => handleChange("itemSelectionType", value)}
                  title={t("Selected items")}
                />
              </div>
              {isSelectedItems && (
                <>
                  <div className="mt-3">
                    <AppInput
                      label={t("Search items")}
                      value={searchTerm}
                      placeholder={t("Search item")}
                      onChange={handSearch}
                    />
                  </div>
                  {renderSelectionList(
                    Items,
                    props?.state?.values?.selectedItems,
                    addItem,
                    "title"
                  )}
                </>
              )}
            </div>

        </div>

      }
      {
        currentStep==2 && 
         <div>
            <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
              <AppInput
                label={t("Total number of uses")}
                value={getValue("maxUsage")}
                error={props?.state?.errors?.maxUsage}
                mandatory={true}
                onChange={(e) => updatePrice("maxUsage", e.target.value)}
              />
            </div>
          </div>
      }
      {
        currentStep==3 &&
        <div>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <AppDatePicker
              label={t("Start Date")}
              value={props?.state?.values?.startDate ? moment(props?.state?.values?.startDate, ["YYYY-MM-DD", "DD-MM-YYYY", C.DATE_FORMAT]).format("YYYY-MM-DD") : null}
              error={props?.state?.errors?.startDate}
              onChange={(date, dateString) => {
                const isoDate = date ? moment(date).locale("en").tz(moment.tz.guess()).format() : "";
                props.setState((prevState) => ({
                  ...prevState,
                  values: {
                    ...prevState.values,
                    startDate: dateString,
                    isoDate,
                  },
                  errors: {
                    ...prevState.errors,
                    startDate: "",
                  },
                }));
              }}
            />
            <AppDatePicker
              label={t("End Date")}
              value={props?.state?.values?.endDate ? moment(props?.state?.values?.endDate, ["YYYY-MM-DD", "DD-MM-YYYY", C.DATE_FORMAT]).format("YYYY-MM-DD") : null}
              error={props?.state?.errors?.endDate}
              onChange={(date, dateString) => {
                const isoEndDate = date ? moment(date).locale("en").tz(moment.tz.guess()).format() : "";
                props.setState((prevState) => ({
                  ...prevState,
                  values: {
                    ...prevState.values,
                    endDate: dateString,
                    isoEndDate,
                  },
                  errors: {
                    ...prevState.errors,
                    endDate: "",
                  },
                }));
              }}
            />
          </div>
        </div>

      }

      {/* <div className="mb-12">
            <h3 className="mt-5 my-4 text-17px">{t("Discount type")} </h3>
            <div className="py-4 flex flex-wrap">
              <AppRadioButton
                name="discountType"
                value={C.PERCENTAGE}
                disabled={props?.text !== "Add"}
                checked={props?.state?.values?.discountType === C.PERCENTAGE}
                onChange={(value) => handleChange("discountType", value)}
                title={t("Percentage") + " (%)"}
              />
              <AppRadioButton
                name="discountType"
                value="fixed"
                disabled={props?.text !== "Add"}
                checked={props?.state?.values?.discountType === "fixed"}
                onChange={(value) => handleChange("discountType", value)}
                title={t("Fixed value") + " ($)"}
              />
            </div>

            <div className="lg:w-1/2">
              <div className="py-2">
                <TextInput
                  label={t("Amount")}
                  value={getValue("discountAmount")}
                  decimal={false}
                  keyVal={"discountAmount"}
                  mandatory={true}
                  error={props?.state?.errors?.discountAmount}
                  handleValues={updatePrice}
                />
              </div>
            </div>
            <div className=" flex wrap">
              <div className="py-2">
                <TextInput
                  mandatory={true}
                  label={t("Minimum order value")}
                  value={getValue("minOrderValue")}
                  keyVal={"minOrderValue"}
                  error={props?.state?.errors?.minOrderValue}
                  handleValues={updatePrice}
                />
              </div>
              {props?.state?.values?.discountType === C.PERCENTAGE && (
                <div className="py-2 px-4">
                  <TextInput
                    mandatory={true}
                    label={t("Maximum discount")}
                    value={getValue("maximumDiscountValue")}
                    keyVal={"maximumDiscountValue"}
                    error={props?.state?.errors?.maximumDiscountValue}
                    handleValues={updatePrice}
                  />
                </div>
              )}
            </div>
          </div> */}
      

    
        {/* <Steps current={1}  labelPlacement="vertical" items={steps}/> */}
        {/* <h1 className="text-blue-600 text-19px pt-4">
          {props?.text === "Add" ? t("Add a discount") : t("Update Discount")}
        </h1> */}
        <div className="lg:w-2/3">
          {/* <div className="py-2">
            <TextInput
              label={ t("Discount name")}
              placeHolder={t("E.g. Taco Tuesday!")}
              value={getValue("discountName")}
              keyVal={"discountName"}
              mandatory={true}
              error={props?.state?.errors?.discountName}
              handleValues={handleChange}
            />
          </div>

          <div className="py-2">
            <TextInput
              label={
                t("Discount code") +
                " " +
                t("Only small letters & numeric values are allowed")
              }
              placeHolder={t("E.g. happy100")}
              value={getValue("discountCode")}
              keyVal={"discountCode"}
              disabled={props?.text === "Add" ? false : true}
              mandatory={true}
              error={props?.state?.errors?.discountCode}
              handleValues={handleDiscountCode}
            />
          </div> */}

          {/* <div className="my-12">
            <h3 className="mt-5 mb-4 text-17px">{t("Application")}</h3>
            <div className=" w-full py-1">
              <div className="flex mb-4 items-center">
                <div>
                  <AppRadioButton
                    name="applicationType"
                    value={C.COUPUN_APPLICATION_TYPE.MANUAL}
                    checked={
                      props?.state?.values?.applicationType ===
                      C.COUPUN_APPLICATION_TYPE.MANUAL
                    }
                    onChange={(value) => handleChange("applicationType", value)}
                    title={t("Manual")}
                  />
                </div>
                <div>
                  <h3 className="font-16px  ">{t("Manual")}</h3>
                  <p className="text-gray-600">
                    {t(
                      "Will be displayed on the store front, and customers will have to select it if they wish to use it"
                    )}
                  </p>
                </div>
              </div>
              <div className="flex mb-4 items-center">
                <div>
                  <AppRadioButton
                    name="applicationType"
                    value={C.COUPUN_APPLICATION_TYPE.HIDDEN}
                    checked={
                      props?.state?.values?.applicationType ===
                      C.COUPUN_APPLICATION_TYPE.HIDDEN
                    }
                    onChange={(value) => handleChange("applicationType", value)}
                    title={t("Hidden Code")}
                  />
                </div>
                <div>
                  <h3 className="font-16px ">{t("Hidden Code")}</h3>
                  <p className="text-gray-600">
                    {t(
                      "Won’t be displayed on the store front, and customers will type the code at the checkout"
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div> */}
{/* 
          <div className="my-12">
            <h3 className="mt-5 mb-4 text-17px">{t("Order type")}</h3>
            {
              <div className="flex">
                {[
                  {
                    label: t("DELIVERY"),
                    serviceName: "DELIVERY",
                  },
                  {
                    label: t("PICKUP"),
                    serviceName: "PICKUP",
                  },
                  ...(getBuisnessType() !== C.BRAND_BASED
                    ? [
                        {
                          label: t("DINEIN"),
                          serviceName: "DINE IN",
                        },
                      ]
                    : []),
                ].map((item, index) => (
                  <AppCheckbox
                    key={`${item?.serviceName}-${index}`}
                    label={item?.label}
                    checked={props?.state?.values.serviceType.some(
                      (service) => service.serviceName === item?.serviceName
                    )}
                    onChange={() =>
                      handleServiceTypes("orderType", {
                        serviceName: item?.serviceName,
                      })
                    }
                  />
                ))}
              </div>
            }
          </div> */}
{/* 
          <div className="my-12">
            <h3 className="mt-5 mb-4 text-17px">{t("Applicable outlets")}</h3>
            <div className="py-2 flex flex-wrap">
              <AppRadioButton
                name="outletSelectionType"
                value={C.ALL}
                checked={props?.state?.values?.outletSelectionType === C.ALL}
                onChange={(value) => handleChange("outletSelectionType", value)}
                title={t("All outlets")}
              />
              <AppRadioButton
                name="outletSelectionType"
                value={C.SELECTED}
                checked={
                  props?.state?.values?.outletSelectionType === C.SELECTED
                }
                onChange={(value) => handleChange("outletSelectionType", value)}
                title={t("Selected outlets")}
              />
            </div>
            {props?.state?.values?.outletSelectionType === C.SELECTED && (
              <div className="border border-gray-200 p-4 mt-4">
                {stores?.map((store, index) => (
                  <div
                    key={index}
                    className="flex w-full py-1"
                    onClick={() => {
                      addStore(store?.value);
                    }}
                  >
                    {props?.state?.values?.selectedOutlets?.includes(
                      store?.value
                    ) ? (
                      <div className="flex justify-between">
                        <span
                          className={`block relative w-5 h-5 border cursor-pointer border-gray-200 bg-gray-200 check`}
                        ></span>
                        <div className="px-2">{store?.label} </div>
                      </div>
                    ) : (
                      <div className="flex justify-between">
                        <span
                          className={`block relative w-5 h-5 border cursor-pointer border-gray-200 bg-gray-200 `}
                        ></span>
                        <div className="px-2">{store?.label} </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div> */}
          

          {/* <div className="mb-12">
            <h3 className="mt-5 mb-4 text-17px">{t("Discount items")} </h3>
            <div className="py-4 flex flex-wrap">
              <AppRadioButton
                name="itemSelectionType"
                value={C.ALL}
                checked={props?.state?.values?.itemSelectionType === C.ALL}
                onChange={(value) => handleChange("itemSelectionType", value)}
                title={t("All items")}
              />
              <AppRadioButton
                name="itemSelectionType"
                value={C.SELECTED}
                checked={props?.state?.values?.itemSelectionType === C.SELECTED}
                onChange={(value) => handleChange("itemSelectionType", value)}
                title={t("Selected items")}
              />
            </div>
            {props?.state?.values?.itemSelectionType === C.SELECTED && (
              <>
                <div className="flex flex-col sm:flex-row justify-between my-4 mb-2">
                  <div className="align-middle text-17px">
                    {t("Discount applies to")}
                  </div>
                  <div classN="flex flex-col sm:flex-row">
                    <div className="flex justify-end"></div>
                    <div className="group relative mt-4 sm:mt-0">
                      <svg
                        fill="currentColor"
                        className="absolute start-3 w-5 h-5 top-1/2 -mt-2.5 text-slate-400 pointer-events-none group-focus-within:text-blue-500"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        ></path>
                      </svg>
                      <input
                        className="focus:outline-none appearance-none w-full text-16px leading-6 text-slate-900 placeholder-slate-400 rounded-md py-2 ps-10 ring-1 ring-gray-200 shadow-sm"
                        type="text"
                        placeholder={t("search item")}
                        autoComplete="off"
                        value={searchTerm}
                        onChange={handSearch}
                      />
                    </div>
                  </div>
                </div>

                <div className="py-2">
                  {Items?.map((item, index) => (
                    <div
                      className="flex py-2"
                      onClick={() => addItem(item._id)}
                      key={index}
                    >
                      <div className="flex justify-between w-full">
                        <div className="px-2">
                          {item?.baseLanguage?.title}
                          <span className="text-gray-400 px-2">
                            AED {item?.price}
                          </span>
                        </div>
                        {props?.state?.values?.selectedItems?.includes(
                          item._id
                        ) ? (
                          <span className="block relative w-5 h-5 border cursor-pointer border-gray-200 bg-gray-200 check"></span>
                        ) : (
                          <span className="block relative w-5 h-5 border cursor-pointer border-gray-200 bg-gray-200"></span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div> */}
{/* 
          <div className="mb-12">
            <h3 className="mt-5 mb-4 text-17px">
              {t("Customer segmentation")}
            </h3>
            <div className="py-2 flex flex-wrap">
              <AppRadioButton
                name="customerSegmentationType"
                value="all"
                checked={
                  props?.state?.values?.customerSegmentationType === "all"
                }
                onChange={(value) => handleChange("customerSegmentationType", value)}
                title={t("All customers")}
              />
              <AppRadioButton
                name="customerSegmentationType"
                value="new"
                checked={
                  props?.state?.values?.customerSegmentationType === "new"
                }
                onChange={(value) => handleChange("customerSegmentationType", value)}
                title={t("New customers")}
              />
            </div>
            {props?.state?.values?.customerSegmentationType === "all" ? (
              <div className="my-4 w-full sm:w-1/2">
                <TextInput
                  mandatory={true}
                  label={t("Number of uses per customer")}
                  value={getValue("perCustomerUse")}
                  keyVal={"perCustomerUse"}
                  error={props?.state?.errors?.perCustomerUse}
                  handleValues={updatePrice}
                />
              </div>
            ) : null}
          </div> */}

          {/* <div>
            <h3 className="mt-5 mb-4 text-17px">{t("Availability")} </h3>
            <div>
              <Space direction="vertical" size={12}>
                <RangePicker
                  placeholder={[t("Start Date"), t("End Date")]}
                  allowClear={false}
                  onChange={(date, dateString) =>
                    handleSetDate(date, dateString)
                  }
                  inputReadOnly={true}
                  showTime={{ format: "HH:mm" }}
                  format={C.DATE_FORMAT}
                  value={[
                    props?.state?.values?.startDate
                      ? moment(props?.state?.values?.startDate, C.DATE_FORMAT)
                      : null,
                    props?.state?.values?.endDate
                      ? moment(props.state.values.endDate, C.DATE_FORMAT)
                      : null,
                  ]}
                  className="h-11"
                />
              </Space>
            </div>
            <div className="my-4 w-full sm:w-1/2">
              <TextInput
                mandatory={true}
                label={t("Total number of uses")}
                value={getValue("maxUsage")}
                keyVal={"maxUsage"}
                error={props?.state?.errors?.maxUsage}
                handleValues={updatePrice}
              />
            </div>
          </div> */}
        </div>
      </div>
      <footer className="z-10 flex shrink-0 flex-col items-stretch justify-end gap-3 border-t border-gray-200 bg-white py-4 shadow-[0_-4px_20px_rgba(15,23,42,0.06)] sm:flex-row sm:items-center">
        <AppButton type="button" variant="outline" size="md" className="w-full sm:w-auto" onClick={handleCancelOrBack}>
          {currentStep === 0 ? t("Cancel") : t("Back")}
        </AppButton>
        {currentStep < lastStepIndex ? (
          <AppButton type="button" variant="primary" size="md" className="w-full sm:w-auto" onClick={handleNext}>
            {t("Next")}
          </AppButton>
        ) : (
          <AppButton
            type="button"
            variant="primary"
            size="md"
            className="w-full sm:w-auto"
            disabled={stores?.length <= 0 || items?.length <= 0}
            onClick={handleSubmitDiscount}
          >
            {props?.text === "Add" ? t("Add discount") : t("Update Discount")}
          </AppButton>
        )}
      </footer>
    </div>
  );
};

export default DiscountForm;
